import { useQuery } from "@tanstack/react-query";
import { useORPCQuery } from "Core/oRPC";
import { getQueryRenderingStatus, Images } from "Shared/Utils";

export const usePersonImage = (alias: string | undefined, enabled = true) => {
    const { coreApi } = useORPCQuery();
    const result = useQuery(
        coreApi.getProfilePhoto.queryOptions({
            input: { alias: alias },
            staleTime: Infinity,
            enabled: enabled && !!alias,
            select: (r) => Images.getBase64ImgSrc(r)
        })
    );

    return {
        personImageUrl: result.data,
        personImageLoadingStatus: getQueryRenderingStatus(result)
    };
};
